export default __webpack_public_path__ + "static/black-02c945d73097d8eba02e8e9ae47de5ab.png";